import { createSelector } from '@reduxjs/toolkit';
import { Logger } from 'aws-amplify';
import React from 'react';

import { NotificationBadge } from 'src/components/NotificationBadge';
import { FlagsContext } from 'src/context';
import { useNotificationBadgeData } from 'src/hooks/useNotificationBadgeData';
import { useAppSelector } from 'src/hooks/useStore';
import { RootState } from 'src/store';
import { NewInvoiceNotification } from 'src/store/notifications/types';
import { isUnreadNotification } from 'src/utils/NotificationsUtils';

const logger = new Logger('InvoiceNotificationsBadge');

const selectInvoiceNotifications = createSelector(
  (state: RootState) => state.notifications.newInvoiceNotifications,
  (state: RootState) => state.activeCompany.activeCompanyId,
  (_: RootState, EnableManyCompanies: boolean) => EnableManyCompanies,
  (apiNotifications, activeCompanyId, EnableManyCompanies) =>
    EnableManyCompanies
      ? apiNotifications.filter((notif) => notif.companyId === activeCompanyId)
      : apiNotifications,
);

// InvoiceNotificationsBadge notifications for forms events
export const InvoiceNotificationsBadge = () => {
  const isClient = useAppSelector((state: RootState) => state.user.isClient);
  const { EnableManyCompanies } = React.useContext(FlagsContext);
  let notifications: NewInvoiceNotification[] = [];
  // Get the notifications from the store according to the user role
  if (isClient) {
    notifications = useAppSelector((state) =>
      selectInvoiceNotifications(state, EnableManyCompanies),
    );
  }

  const [notificationsCounter, setNotificationsCounter] = React.useState(0);

  React.useEffect(() => {
    logger.debug('Setting primary invoice sidebar notification');
    // filter unread notification
    logger.debug('Total notifications:', notifications.length);
    const unreadNotifications = notifications.filter((notif) =>
      isUnreadNotification(notif.ownerId),
    );

    logger.debug('Unread notifications:', unreadNotifications.length);

    setNotificationsCounter(unreadNotifications.length);
  }, [notifications]);

  const { backgroundColor, textColor } = useNotificationBadgeData(true); // isSidebar = true

  return (
    <NotificationBadge
      showZero={false}
      isSidebar
      content={notificationsCounter}
      backgroundColor={backgroundColor}
      textColor={textColor}
    />
  );
};
